export enum TimeSlotFilterType {
  Any = 0,
  Today = 10,
  Tomorrow = 11,
  Week = 20,
  NextWeek = 21,
  Month = 30,
}
